import Vue from 'vue'
import Router from 'vue-router'
import i18n from '@/helpers/i18n';

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Login = () => import('@/views/Login')
const PrivacyPolicy = () => import('@/views/PrivacyPolicy')
const Page404 = () => import('@/views/Page404');
const Page500 = () => import('@/views/Page500');

// Views - Pages
const HerosList = () => import('@/views/Heros/HerosList')
const HeroAdd = () => import('@/views/Heros/HeroAdd')
const HeroEdit = () => import('@/views/Heros/HeroEdit')
const KeyValuesList = () => import('@/views/KeyValues/KeyValuesList')
const KeyValueAdd = () => import('@/views/KeyValues/KeyValueAdd')
const KeyValueEdit = () => import('@/views/KeyValues/KeyValueEdit')
const ProjectsList = () => import('@/views/Projects/ProjectsList')
const ProjectAdd = () => import('@/views/Projects/ProjectAdd')
const ProjectEdit = () => import('@/views/Projects/ProjectEdit')
const ServicesList = () => import('@/views/Services/ServicesList')
const ServiceAdd = () => import('@/views/Services/ServiceAdd')
const ServiceEdit = () => import('@/views/Services/ServiceEdit')
const StaticInfosList = () => import('@/views/StaticInfos/StaticInfosList')
const StaticInfoAdd = () => import('@/views/StaticInfos/StaticInfoAdd')
const StaticInfoEdit = () => import('@/views/StaticInfos/StaticInfoEdit')
const Profile = () => import('@/views/Profile')


Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '/',
      redirect: `/${i18n.t('heros')}/${i18n.t('list')}`,
      name: 'Home',
      component: TheContainer,
      children: [
                {
          path: i18n.t('heros'),
          redirect: '/' + i18n.t('heros') + '/' + i18n.t('list'),
          name: 'Heros',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: i18n.t('list'),
              name: 'HerosList',
              component: HerosList
            },
            {
              path: i18n.t('add'),
              name: 'HeroAdd',
              component: HeroAdd
            },
            {
              path: i18n.t('edit'),
              name: 'HeroEdit',
              component: HeroEdit
            },
          ]
        },
        {
          path: i18n.t('keyValues'),
          redirect: '/' + i18n.t('keyValues') + '/' + i18n.t('list'),
          name: 'KeyValues',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: i18n.t('list'),
              name: 'KeyValuesList',
              component: KeyValuesList
            },
            {
              path: i18n.t('add'),
              name: 'KeyValueAdd',
              component: KeyValueAdd
            },
            {
              path: i18n.t('edit'),
              name: 'KeyValueEdit',
              component: KeyValueEdit
            },
          ]
        },
        {
          path: i18n.t('projects'),
          redirect: '/' + i18n.t('projects') + '/' + i18n.t('list'),
          name: 'Projects',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: i18n.t('list'),
              name: 'ProjectsList',
              component: ProjectsList
            },
            {
              path: i18n.t('add'),
              name: 'ProjectAdd',
              component: ProjectAdd
            },
            {
              path: i18n.t('edit'),
              name: 'ProjectEdit',
              component: ProjectEdit
            },
          ]
        },
        {
          path: i18n.t('services'),
          redirect: '/' + i18n.t('services') + '/' + i18n.t('list'),
          name: 'Services',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: i18n.t('list'),
              name: 'ServicesList',
              component: ServicesList
            },
            {
              path: i18n.t('add'),
              name: 'ServiceAdd',
              component: ServiceAdd
            },
            {
              path: i18n.t('edit'),
              name: 'ServiceEdit',
              component: ServiceEdit
            },
          ]
        },
        {
          path: i18n.t('staticInfos'),
          redirect: '/' + i18n.t('staticInfos') + '/' + i18n.t('list'),
          name: 'StaticInfos',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: i18n.t('list'),
              name: 'StaticInfosList',
              component: StaticInfosList
            },
            {
              path: i18n.t('add'),
              name: 'StaticInfoAdd',
              component: StaticInfoAdd
            },
            {
              path: i18n.t('edit'),
              name: 'StaticInfoEdit',
              component: StaticInfoEdit
            },
          ]
        },
        // Profile
        {
          path: i18n.t('profile'),
          name: 'Profile',
          component: Profile
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/privacypolicy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy
    },
    {
      path: '/404',
      name: '404',
      component: Page404
    },    
    {
      path: '/500',
      name: '500',
      component: Page500
    }, 
  ]
}

